import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function Method() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: cardsRef, visibleItems } = useStaggerAnimation(3, { threshold: 0.1 });
  const { ref: quoteRef, isVisible: quoteVisible } = useScrollAnimation({ threshold: 0.2 });

  const steps = [
    {
      num: '01',
      title: 'Análisis estratégico',
      desc: 'Diagnóstico profundo de necesidades empresariales o perfil profesional. Entendemos la cultura, objetivos y expectativas reales de ambas partes.',
      icon: 'ri-search-line',
    },
    {
      num: '02',
      title: 'Selección precisa',
      desc: 'Evaluación rigurosa de competencias, experiencia y alineación cultural. No enviamos perfiles al azar, creamos matches estratégicos.',
      icon: 'ri-user-star-line',
    },
    {
      num: '03',
      title: 'Acompañamiento real',
      desc: 'Seguimiento continuo hasta lograr un encaje sólido y sostenible. Estamos presentes en cada etapa del proceso de integración.',
      icon: 'ri-hand-heart-line',
    },
  ];

  return (
    <section id="method" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className="text-center mb-20"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(32px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
          }}
        >
          <h2 className="text-5xl font-bold text-[#1A2B4A] mb-4">Nuestro método</h2>
          <p className="text-xl text-gray-600">Diseñamos conexiones que funcionan</p>
        </div>

        <div
          ref={cardsRef as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16"
        >
          {steps.map((step, i) => (
            <div
              key={step.num}
              className="relative bg-white p-10 rounded-xl shadow-sm hover:shadow-lg transition-shadow"
              style={{
                opacity: visibleItems[i] ? 1 : 0,
                transform: visibleItems[i] ? 'translateY(0)' : 'translateY(40px)',
                transition: 'opacity 0.6s ease, transform 0.6s ease',
              }}
            >
              <div className="absolute top-8 left-8 text-8xl font-extrabold text-[#1A2B4A]/5 leading-none">{step.num}</div>
              <div className="relative z-10">
                <h3 className="text-2xl font-bold text-[#1A2B4A] mb-6 mt-8">{step.title}</h3>
                <p className="text-gray-700 leading-relaxed mb-8">{step.desc}</p>
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A2B4A]/10 rounded-full">
                  <i className={`${step.icon} text-2xl text-[#1A2B4A]`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          ref={quoteRef as React.RefObject<HTMLDivElement>}
          className="bg-[#F8F6F3] p-10 rounded-xl shadow-sm text-center max-w-3xl mx-auto"
          style={{
            opacity: quoteVisible ? 1 : 0,
            transform: quoteVisible ? 'scale(1)' : 'scale(0.96)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
          }}
        >
          <p className="text-xl italic text-gray-800 leading-relaxed">
            "No enviamos perfiles al azar. No gestionamos procesos en masa."
          </p>
        </div>
      </div>
    </section>
  );
}
